import { Component } from '@angular/core';

/**
 * This component is used to gather application feedback from users.
 */
@Component({
	selector: 'cc-feedback',
	templateUrl: './feedback.component.html',
	styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent {

// #region [ Constructor ]

	constructor(
	) { }	
}